export interface EmpresaCliente {
  id: string;
  nome: string;
  cnpj: string;
  emailAdmin: string;
  senha: string;
  logo?: string;
  grupoId?: string;
}

export const empresasClientes: EmpresaCliente[] = [
  {
    id: 'EMP-001',
    nome: 'getPoints',
    cnpj: '12.345.678/0001-90',
    emailAdmin: 'admin@getpoints.com.br',
    senha: '123456',
    grupoId: 'GRUPO-001',
  },
  {
    id: 'EMP-002',
    nome: 'Inovação Digital S.A.',
    cnpj: '98.765.432/0001-10',
    emailAdmin: 'admin@inovacaodigital.com.br',
    senha: 'inovacao2024',
    grupoId: 'GRUPO-002',
  },
  {
    id: 'EMP-003',
    nome: 'Consultoria Tech Brasil',
    cnpj: '45.678.901/0001-23',
    emailAdmin: 'admin@techbrasil.com.br',
    senha: 'tech2024',
    grupoId: 'GRUPO-001',
  },
  {
    id: 'EMP-004',
    nome: 'Sistemas Integrados Ltda',
    cnpj: '23.456.789/0001-45',
    emailAdmin: 'admin@sistemasintegrados.com.br',
    senha: 'sistemas2024',
    grupoId: 'GRUPO-002',
  },
];

export function getEmpresaClienteByEmail(email: string): EmpresaCliente | undefined {
  return empresasClientes.find(e => e.emailAdmin === email);
}

export function getEmpresaClienteById(id: string): EmpresaCliente | undefined {
  return empresasClientes.find(e => e.id === id);
}